import BookPromptGroup from "components/BookGroup/groups/BookPromptGroup";
import { PromptSerializersPromptUser, UserSerializersUserByline } from "types/serializers";

export default function UserPrompts({
  user,
  prompts,
}: {
  user: UserSerializersUserByline;
  prompts: PromptSerializersPromptUser[];
}) {
  return (
    <div className="mt-4 divide-y-2 divide-gray-100 dark:divide-gray-700 ">
      {prompts.map((prompt) => (
        <div key={`prompt-${prompt.id}`} className="py-4 lg:py-8">
          <BookPromptGroup
            key={`book-prompt-${prompt.id}`}
            prompt={prompt}
            size={prompt.featured ? "lg" : "md"}
            context={{
              hidePosition: true,
              link: `/@${user.username}/prompts/${prompt.slug}`,
              referrerId: user.id,
            }}
          />
        </div>
      ))}
    </div>
  );
}
